import { render } from "./BonfireResult.vue?vue&type=template&id=594c5119&scoped=true"
import script from "./BonfireResult.vue?vue&type=script&lang=js"
export * from "./BonfireResult.vue?vue&type=script&lang=js"

import "./BonfireResult.vue?vue&type=style&index=0&id=594c5119&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594c5119"]])

export default __exports__